import { Animation } from '@motionone/animation';
import { createAnimate } from './create-animate.es.js';

const animate = createAnimate(Animation);

export { animate };
